import { Select, Switch, Text, Textarea } from "@mantine/core";
import { HttpError, IResourceComponentsProps } from "@refinedev/core";
import { Edit, useForm } from "@refinedev/mantine";
import DateTimePicker from "components/common/DateTimePicker";
import { UpdateTeaAddonSubscription } from "entities/tea_addon_subscription";
import { selectStatuses } from "entities/tea_addon_subscription/status";

export const TeaAddonSubscriptionEdit: React.FC<
  IResourceComponentsProps
> = () => {
  const {
    getInputProps,
    saveButtonProps,
    values,
    setFieldValue,
    refineCore: { queryResult },
  } = useForm<
    UpdateTeaAddonSubscription,
    HttpError,
    UpdateTeaAddonSubscription
  >({
    refineCoreProps: {
      redirect: "show",
    },
    initialValues: {
      started_at: new Date(),
      last_payment_at: new Date(),
      next_renewal_at: new Date(),
      canceled_at: new Date(),
      status: "active",
      notes: "",
      prevent_auto_date_alignment: false,
      dunning_attempt_count: 0,
      initial_dunning_failure_at: null,
      next_dunning_at: null,
    },
  });

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      canDelete={false}
      title="Update tea addon subscription"
    >
      <Select
        placeholder="Status"
        data={selectStatuses}
        label="Status"
        {...getInputProps("status")}
      />
      <DateTimePicker
        type="date"
        label="Started At"
        defaultValue={new Date()}
        mt="sm"
        min={0}
        max={10}
        {...getInputProps("started_at")}
      />
      <DateTimePicker
        type="date"
        label="Next Renewal At"
        defaultValue={new Date()}
        mt="sm"
        min={0}
        max={10}
        {...getInputProps("next_renewal_at")}
      />
      <Switch
        mt="sm"
        label="Prevent Auto Date Alignment"
        description="When enabled, the tea addon next renewal date will progress 1 month at a time without trying to align it with the parent Chargebee subscription. The date will not be automatically adjusted when the parent subscription's billing date changes."
        {...getInputProps("prevent_auto_date_alignment", {
          type: "checkbox",
        })}
      />
      <DateTimePicker
        type="date"
        label="Last Payment At"
        defaultValue={new Date()}
        mt="sm"
        min={0}
        max={10}
        clearable
        {...getInputProps("last_payment_at")}
      />
      <DateTimePicker
        type="date"
        label="Canceled At"
        defaultValue={new Date()}
        mt="sm"
        min={0}
        max={10}
        clearable
        {...getInputProps("canceled_at")}
      />
      <Textarea
        defaultValue=""
        mt="sm"
        label="Notes"
        {...getInputProps("notes")}
      />
    </Edit>
  );
};
